import { useTranslation } from "react-i18next";
import "../../assets/stylesheets/UnableToAccess.scss";
import { useSelector } from "react-redux";
import { getUserRoles } from "../../utils/userRoleHelper";
import { Button } from "@raspberrypifoundation/design-system-react";

const UnableToAccess = () => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language;
  const school = useSelector((state) => state.school);
  const userRoles = getUserRoles(school);

  return (
    <main className="unable-to-access">
      <div className="unable-to-access__container">
        <div className="unable-to-access___container-content">
          <h1 className="unable-to-access__container-title">
            {t("unableToAccess.title")}
          </h1>
          <div className="unable-to-access__container-description">
            <p> {t("unableToAccess.couldBeBecause")}</p>
            <ul>
              <li> {t("unableToAccess.doesNotExist")}</li>
              <li> {t("unableToAccess.incorrectLink")}</li>
              <li> {t("unableToAccess.noAccessToPage")}</li>
            </ul>
          </div>
        </div>
        <div className="unable-to-access__links">
          <div className="unable-to-access__links-buttons">
            <Button
              text={t("unableToAccess.codeClassroomHome")}
              type="secondary"
              textAlways
              href="/"
            />
            {!!userRoles.length && (
              <Button
                text={t("unableToAccess.goToYourSchool")}
                type="primary"
                textAlways
                href={`/${locale}/school`}
              />
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default UnableToAccess;
